import React, { useState, useEffect } from "react";
import DropDownArrow from "../../img/dropdown-arrow.svg";
import "./MCM.scss";

/**
 * Многоуровневое меню категорий
 *
 * \- Подменю открывается при наведении (`onMouseEnter`).
 * \- Категория считается «выбранной» и подсвечивается **только после клика**.
 * \- Коллбек `onCategorySelect` вызывается только при клике, а не при наведении.
 */

const CategoryItem = ({ category, depth, clickedPath, onHover, onClick }) => {
  const isClicked = clickedPath[depth]?.id === category.id;

  return (
    <li
      className={`category_li ${isClicked ? "selected" : ""}`}
      onMouseEnter={() => onHover(category, depth)}
      onClick={() => onClick(category, depth)}
    >
      {category.name}
    </li>
  );
};

const MultilevelCategoryMenu = ({ categories = [], onCategorySelect, isDropDown = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [clickedPath, setClickedPath] = useState([]); // путь, подтверждённый кликом
  const [activePath, setActivePath] = useState([]);   // путь, сформированный наведением

  /* Передаём выбранную (кликнутую) категорию наружу */
  useEffect(() => {
    if (clickedPath.length) {
      onCategorySelect(clickedPath[clickedPath.length - 1].id);
    }
  }, [clickedPath, onCategorySelect]);

  /** Обработка наведения: формируем `activePath`, но **не** делаем выбор */
  const handleHover = (category, depth) => {
    setActivePath(prev => {
      const next = prev.slice(0, depth);
      next[depth] = category;
      return next;
    });
  };

  /** Клик фиксирует текущий `activePath` как выбор */
  const handleClick = (category, depth) => {
    const newClicked = [...activePath.slice(0, depth), category];
    setClickedPath(newClicked);
  };

  /** При выходе курсора за пределы меню возвращаем отображение к "подтверждённому" пути */
  const handleMouseLeave = () => {
    setActivePath(clickedPath);
  };

  /** Корневой + дочерние уровни для рендера */
  const columns = [categories, ...activePath.map(c => c?.children).filter(Boolean)];

  return (
    <div className="subcaterogy_menu" onMouseLeave={handleMouseLeave}>
      <div
        className={`category_title_con ${isDropDown ? "drop_down" : ""}`}
        onClick={() => {
          setIsOpen(prev => !prev);
          if (isOpen) {
            // если закрываем меню — сбрасываем всё
            setActivePath([]);
            setClickedPath([]);
          }
        }}
      >
        <div className="category_title">Категорії</div>
        <img
          className={`dropdown_arrow_img ${isOpen ? "active" : ""}`}
          src={DropDownArrow}
          alt="dropdown"
        />
      </div>

      <div className={`drop_down_con ${(!isDropDown || isOpen) ? "open" : ""}`}>
        {columns.map((level, idx) => (
          <ul key={idx} className={`category_column ${level?.length && "expanded"}`}>
            {level.map(cat => (
              <CategoryItem
                key={cat.id}
                category={cat}
                depth={idx}
                clickedPath={clickedPath}
                onHover={handleHover}
                onClick={handleClick}
              />
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
};

export default MultilevelCategoryMenu;
